import { i18nFilter } from "app/filters/i18nFilter";
import type { ICustomSegment } from "app/services/segments/segmentsApiService";
import type { IconName } from "@similarweb/icons";
import { HOOKS_ICON_GRAY } from "app/constants/hooks";

export interface IActionItem {
    id: string;
    iconName: IconName;
    text: string;
    onClickFunc: VoidFunction;
}

type OnActionClick = (row: ICustomSegment) => void;

export const getActionItems = (
    segment: ICustomSegment,
    onClickEdit?: OnActionClick,
    onClickDuplicate?: OnActionClick,
    onClickShare?: OnActionClick,
    onCopySegmentToUser?: OnActionClick,
    onClickDelete?: OnActionClick,
    isLimitationExceeded?: boolean,
) => {
    const edit: IActionItem = {
        id: "edit",
        iconName: "edit",
        text: i18nFilter()("segment.analysis.table.additional.options.edit"),
        onClickFunc: () => onClickEdit(segment),
    };
    const copyAndEdit: IActionItem = {
        id: "copyAndEdit",
        iconName: isLimitationExceeded ? HOOKS_ICON_GRAY : "copy-and-edit",
        text: i18nFilter()("segment.analysis.table.additional.options.copy.and.edit"),
        onClickFunc: () => onClickDuplicate(segment),
    };
    const share: IActionItem = {
        id: "share",
        iconName: "share-new",
        text: i18nFilter()("segment.analysis.table.additional.options.share"),
        onClickFunc: () => onClickShare(segment),
    };
    const copyToUser: IActionItem = {
        id: "copyToUser",
        iconName: "copy",
        text: i18nFilter()("segment.analysis.table.additional.options.copy.to.user"),
        onClickFunc: () => onCopySegmentToUser(segment),
    };
    const deleteObj: IActionItem = {
        id: "delete",
        iconName: "delete",
        text: i18nFilter()("segments.module.additional.options.delete.segment"),
        onClickFunc: () => onClickDelete(segment),
    };

    return {
        edit,
        copyAndEdit,
        share,
        copyToUser,
        deleteObj,
    };
};
